import React from "react";
import { Row, Col, Card, CardBody, Badge, Nav, NavItem, NavLink } from "reactstrap";
import CommonDataTable from "../../../common/DataTable";
import { StatCard } from "../../../Components/Common/StatCard";
import {
    getAdminInsightsConfig,
    getBidHistoryColumns,
    getFinancialOverviewConfig,
    getQuickStatsConfig,
    InfoRow
} from "../../../Components/Common/columns/BidTranjections";
import { getSummaryCardsConfig } from "../../../Components/Common/config/userHistoryConfig";
import BalanceHistoryTab from "./BalanceHistoryTab";
import GameHistoryTab from "./GameHistoryTab";

const LuckyTarget1 = ({
    historyData = {},
    historyLoading,
    filters,
    activeTab,
    setActiveTab,
    userId,
    onFetchData,
    handlePageChange,
    handleRowsPerPageChange
}) => {
    const { tabsConfig } = require("../../../Components/Common/columns/BidTranjections");
    const classnames = require('classnames');

    // Extract data from historyData
    const pagination = historyData.pagination || {};
    const recentBids = historyData.detailedHistory?.recentBids || [];
    const currentAccountStatus = historyData.currentAccountStatus || {};
    const financialSummary = historyData.financialSummary || {};
    const bidAnalysis = historyData.bidAnalysis || {};
    const adminInsights = historyData.adminInsights || {};
    const quickStats = historyData.quickStats || {};

    // Get configurations
    const summaryCards = getSummaryCardsConfig(currentAccountStatus, financialSummary);
    const financialOverviewData = getFinancialOverviewConfig(financialSummary, bidAnalysis);
    const quickStatsData = getQuickStatsConfig(quickStats);
    const adminInsightsData = getAdminInsightsConfig(adminInsights);
    const bidsColumns = getBidHistoryColumns();

    return (
        <>
            {/* Summary Cards */}
            <div className="p-3 bg-white border-bottom">
                <Row>
                    {summaryCards.map((card, idx) => (
                        <Col md={3} sm={6} key={idx}>
                            <StatCard {...card} />
                        </Col>
                    ))}
                </Row>
            </div>

            {/* Financial Overview */}
            <div className="p-3 bg-white border-bottom">
                <h6 className="mb-3 fw-semibold">
                    <i className="ri-money-dollar-circle-line me-2 text-primary"></i>
                    Financial Overview - Lucky Target 1
                </h6>
                <Row>
                    {financialOverviewData.map((colData, idx) => (
                        <Col md={4} key={idx}>
                            <Card className="border-0 shadow-sm">
                                <CardBody>
                                    {colData.map((item, itemIdx, array) => (
                                        <InfoRow
                                            key={itemIdx}
                                            {...item}
                                            noBorder={itemIdx === array.length - 1}
                                        />
                                    ))}
                                </CardBody>
                            </Card>
                        </Col>
                    ))}
                </Row>
            </div>

            {/* Tabs Navigation */}
            <Nav tabs className="px-3 pt-3 bg-white">
                {tabsConfig.map(tab => (
                    <NavItem key={tab.id}>
                        <NavLink
                            className={classnames({ active: activeTab === tab.id })}
                            onClick={() => setActiveTab(tab.id)}
                            style={{
                                cursor: 'pointer',
                                borderRadius: '8px 8px 0 0',
                                fontWeight: activeTab === tab.id ? '600' : '400'
                            }}
                        >
                            <i className={`${tab.icon} me-2`}></i>
                            {tab.label}
                        </NavLink>
                    </NavItem>
                ))}
            </Nav>

            {/* Tab Content */}
            <div className="p-3 bg-white">
                {/* Tab 1 – Bid History */}
                {activeTab === '1' && (
                    <div>
                        {recentBids.length === 0 ? (
                            <div className="text-center py-5">
                                <i className="ri-inbox-line" style={{ fontSize: "48px", color: "#dee2e6" }} />
                                <p className="text-muted mt-3">No bids found for this user in Lucky Target 1</p>
                            </div>
                        ) : (
                            <div style={{ overflowX: 'hidden' }}>
                                <CommonDataTable
                                    columns={bidsColumns}
                                    data={recentBids}
                                    loading={historyLoading}
                                    totalRows={pagination.totalBids || 0}
                                    filterParams={filters}
                                    fetchData={(newParams) => {
                                        if (userId && onFetchData) onFetchData(newParams);
                                    }}
                                    cardcusclass="mt-0 mb-0"
                                    callcusclass="p-0 mt-0"
                                    searchEnable={false}
                                    showAddButton={false}
                                    showExportButton={false}
                                    checkboxEnabled={false}
                                    paginationPerPage={filters.limit || 10}
                                    paginationDefaultPage={filters.page || 1}
                                    onChangePage={handlePageChange}
                                    onChangeRowsPerPage={handleRowsPerPageChange}
                                    striped
                                    highlightOnHover
                                    noHeader
                                />
                            </div>
                        )}
                    </div>
                )}

                {/* Tab 2 – Balance History */}
                {activeTab === '2' && (
                    <BalanceHistoryTab userId={userId} gameType={filters.gameType || 'lt1'} />
                )}

                {activeTab === '4' && <GameHistoryTab userId={userId} />}

                {/* Tab 3 – Statistics */}
                {activeTab === '3' && (
                    <Row>
                        <Col md={6}>
                            <Card className="mb-3 border-0 shadow-sm">
                                <CardBody>
                                    <h6 className="mb-3 fw-semibold">
                                        <i className="ri-numbers-line me-2 text-primary"></i>
                                        Number Analysis - Lucky Target 1
                                    </h6>
                                    <div className="table-responsive">
                                        <table className="table table-sm table-hover mb-0">
                                            <thead className="table-light">
                                                <tr>
                                                    <th className="fw-semibold">Number</th>
                                                    <th className="fw-semibold">Total Bets</th>
                                                    <th className="fw-semibold">Total Amount</th>
                                                    <th className="fw-semibold">Total Wins</th>
                                                    <th className="fw-semibold">Win Rate</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {Object.entries(bidAnalysis.numberAnalysis || {}).map(([num, data], index, array) => (
                                                    <tr key={num}>
                                                        <td className={index === array.length - 1 ? "border-bottom-0" : ""}>
                                                            <strong className="text-primary">{num}</strong>
                                                        </td>
                                                        <td className={index === array.length - 1 ? "border-bottom-0" : ""}>{data.totalBets || 0}</td>
                                                        <td className={index === array.length - 1 ? "border-bottom-0" : ""}>{data.totalAmount || 0}</td>
                                                        <td className={index === array.length - 1 ? "border-bottom-0" : ""}>{data.totalWins || 0}</td>
                                                        <td className={index === array.length - 1 ? "border-bottom-0" : ""}>
                                                            <Badge
                                                                color={parseFloat(data.winRate) > 50 ? 'success' : 'warning'}
                                                                className="px-2"
                                                            >
                                                                {data.winRate || '0'}%
                                                            </Badge>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                        <Col md={6}>
                            <Card className="mb-3 border-0 shadow-sm">
                                <CardBody>
                                    <h6 className="mb-3 fw-semibold">
                                        <i className="ri-flashlight-line me-2 text-primary"></i>
                                        Quick Stats - Lucky Target 1
                                    </h6>
                                    {quickStatsData.map((stat, index, array) => (
                                        <InfoRow
                                            key={index}
                                            {...stat}
                                            noBorder={index === array.length - 1}
                                        />
                                    ))}
                                </CardBody>
                            </Card>

                            <Card className="mb-3 border-0 shadow-sm">
                                <CardBody>
                                    <h6 className="mb-3 fw-semibold">
                                        <i className="ri-admin-line me-2 text-primary"></i>
                                        Admin Insights - Lucky Target 1
                                    </h6>
                                    {adminInsightsData.map((insight, index, array) => (
                                        <InfoRow
                                            key={index}
                                            {...insight}
                                            noBorder={index === array.length - 1}
                                        />
                                    ))}
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                )}
            </div>
        </>
    );
};

export default LuckyTarget1;